export default {"src":"/_next/static/media/monietab-white.5735664a.svg","height":257,"width":1728,"blurWidth":0,"blurHeight":0};